var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mainAnnotationGroup flex-level flex-top" }, [
    _vm.itemData.avatar
      ? _c(
          "div",
          [
            _c("avatar", {
              staticClass: "icon",
              attrs: { avatar: _vm.itemData.avatar }
            })
          ],
          1
        )
      : _c("div", [
          _vm.itemData.icon_url
            ? _c("div", { staticClass: "icon" }, [
                _c("a", { attrs: { href: "/staff/" + _vm.itemData.ownerid } }, [
                  _c("span", { staticClass: "avatar avatar-picture" }, [
                    _c("img", { attrs: { src: _vm.itemData.icon_url } })
                  ])
                ])
              ])
            : _c("div", {
                staticClass: "icon",
                domProps: { innerHTML: _vm._s(_vm.itemData.icon) }
              })
        ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mainAnnotationContent" },
      [
        _c(
          "div",
          { staticClass: "annotationsInfos" },
          [
            _c("div", { staticClass: "title" }, [
              _c("a", {
                attrs: { href: "/staff/" + _vm.itemData.ownerid },
                domProps: { innerHTML: _vm._s(_vm.itemData.title) }
              })
            ]),
            _vm._v(" "),
            _vm.canEdit || _vm.canDelete
              ? _c(
                  "el-dropdown",
                  { staticClass: "fright" },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "icon-burger",
                          staticStyle: { position: "inherit" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _vm.canEdit
                          ? _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.toggleEditMode()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$l10n.__("Modifier")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canDelete
                          ? _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.deleteAnnot(_vm.itemData)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$l10n.__("Supprimer")))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editMode
              ? _c("div", [
                  _c("div", {
                    staticClass:
                      "textAnnot my-2 ellipsis editor-preview rich-text-style",
                    domProps: {
                      innerHTML: _vm._s(_vm.itemData.annotationHtmlFormated)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "time annotationsInfos__title__time mb-2",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.itemData.dateAndLink
                          ? _vm.itemData.dateAndLink
                          : _vm.itemData.date
                      )
                    }
                  }),
                  _vm._v(" "),
                  _vm.itemData.timetracking &&
                  (_vm.itemData.timetracking.time ||
                    _vm.itemData.timetracking.service)
                    ? _c("div", { staticClass: "ttAnnotation" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Timetracking")) +
                              ": " +
                              _vm._s(_vm.itemData.timetracking.time) +
                              " -\n                        " +
                              _vm._s(_vm.$l10n.__("Service")) +
                              ": " +
                              _vm._s(_vm.itemData.timetracking.service)
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _c(
                  "el-form",
                  {
                    ref: "updateAnnotationForm",
                    staticClass: "mb-0 mt-2",
                    attrs: { rules: _vm.rules, model: _vm.ruleForm }
                  },
                  [
                    _c("RichText", {
                      staticClass: "annotations-list-item-richtext",
                      attrs: {
                        options: _vm.optionsRichText,
                        typeRichText: "comment",
                        showAIComponents: "",
                        hash: _vm.hash
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "actions",
                          fn: function() {
                            return [
                              _vm.itemData.annotation.length !== ""
                                ? _c(
                                    "div",
                                    [
                                      _c("CompassButton", {
                                        attrs: {
                                          label: "Annuler",
                                          type: "secondary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.cancel()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("CompassButton", {
                                        attrs: {
                                          label: "Confirmer",
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.submitForm(
                                              "updateAnnotationForm",
                                              "submitUpdate",
                                              {
                                                id: _vm.itemData.id
                                              }
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.tmpContent,
                        callback: function($$v) {
                          _vm.tmpContent = $$v
                        },
                        expression: "tmpContent"
                      }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.mentionAddedInEditing
              ? _c("div", { staticClass: "fs-2 gray-80 mt-1" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Les notifications ne sont pas envoyées lors d'une édition de commentaire"
                        )
                      ) +
                      "\n            "
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.item["subannots"] && _vm.item["subannots"].length > 0
          ? _c("div", { staticClass: "commentsContainer" }, [
              _vm.item["subannots"].length > 2 && !_vm.displayAllAnnot
                ? _c(
                    "ul",
                    { staticClass: "annotationsList" },
                    [
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "mb--3 prelative zi-1" },
                          [
                            _c("CompassLink", {
                              attrs: {
                                label: _vm.labelDisplayAllAnnot,
                                type: "primary",
                                size: "medium"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleAllAnnot()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.item["subannots"].slice(
                          _vm.item["subannots"].length - 2
                        ),
                        function(subAnnot, indexSubAnnot) {
                          return _c(
                            "li",
                            {
                              key: indexSubAnnot,
                              staticClass: "annotationsGroup mx-0"
                            },
                            [
                              _c("annotations-list-item", {
                                attrs: {
                                  item: { datas: subAnnot },
                                  "is-reply": true
                                },
                                on: { delete: _vm.deleteAnnot }
                              })
                            ],
                            1
                          )
                        }
                      )
                    ],
                    2
                  )
                : _c(
                    "ul",
                    _vm._l(_vm.item["subannots"], function(
                      subAnnot,
                      indexSubAnnot
                    ) {
                      return _c(
                        "li",
                        {
                          key: indexSubAnnot,
                          staticClass: "annotationsGroup mx-0"
                        },
                        [
                          _c("annotations-list-item", {
                            attrs: {
                              item: { datas: subAnnot },
                              "is-reply": true
                            },
                            on: { delete: _vm.deleteAnnot }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isReply
          ? _c("RichText", {
              staticClass: "annotations-list-item-richtext reply",
              attrs: {
                placeholder: _vm.$t.__("common.actions.answer"),
                options: _vm.optionsRichText,
                typeRichText: "comment",
                useStorage: true,
                refRichText: _vm.refRichText,
                showAIComponents: "",
                hash: _vm.hashNewReply
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _vm.newReply.length > 0 && _vm.newReply !== "<p></p>"
                          ? _c(
                              "div",
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: "Annuler",
                                    type: "secondary",
                                    size: "small"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelReply()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("CompassButton", {
                                  attrs: {
                                    label: "Confirmer",
                                    type: "primary",
                                    size: "small"
                                  },
                                  on: { click: _vm.submitReply }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1840530084
              ),
              model: {
                value: _vm.newReply,
                callback: function($$v) {
                  _vm.newReply = $$v
                },
                expression: "newReply"
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }